import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, WritableSignal, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SafeUrl } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription, take } from 'rxjs';
import { PreviewFileFullscreenComponent } from './shared/components';

const DEFAULT_TRANSLATION_LANG = 'ru';

@Component({
    selector: 'anms-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
    CommonModule,
    RouterOutlet,
    PreviewFileFullscreenComponent
]
})
export class AppComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription();

  languages = ['en', 'ru'];

  userDisplayName = '';
  userAvatarImage: SafeUrl;

  currentTheme = 'default-theme';
  translateLoaded: WritableSignal<boolean> = signal(false);

  constructor(
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    this.translate.setDefaultLang(DEFAULT_TRANSLATION_LANG);

    this.subscriptions.add(
      this.translate.onDefaultLangChange.pipe(take(1)).subscribe(
        { next: () => this.onTranslateLoaded() }
      )
    );
  }

  ngOnInit(): void {
    // Чтобы работали оверлеи, например cdk-drag-preview,
    // класс темы должен быть навешан на body
    // https://github.com/angular/components/issues/17089
    this.setTheme(this.currentTheme);
  }

  setTheme(theme: string): void {
    if (this.currentTheme) {
      this.renderer.removeClass(document.body, this.currentTheme);
    }

    if (theme) {
      this.renderer.addClass(document.body, theme);
    }

    this.currentTheme = theme;
  }

  onTranslateLoaded(): void {
    this.translateLoaded.set(true);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
